import AuthForm from '../components/auth/AuthForm';

export default function Auth() {
  return <AuthForm />;
}
